export enum EDateType {
  day = 1, // 日（单天查询）
  week, // 周（7 天范围查询）
  month, // 月（单月查询）
  year, // 年（单年查询）
  custom // 自定义（年月日时分秒）
}
